function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "signal");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-page-/-Student",
  transform: "translate(-48.000000, -695.000000)",
  fill: "#7ED321",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(48.000000, 690.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "signal",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.27914439,7 C3.27914439,5.03895187 4.04228663,3.19529412 5.42806952,1.80867273 C5.83741604,1.39906417 5.83741604,0.734970053 5.42806952,0.325413904 C5.0187754,-0.0842470588 4.35515294,-0.0842470588 3.94580642,0.325361497 C2.16409305,2.10822781 1.1828877,4.47862246 1.1828877,7 C1.1828877,9.52137754 2.16409305,11.8917722 3.94580642,13.6746385 C4.35510053,14.0841947 5.01872299,14.0841947 5.42806952,13.6745861 C5.83741604,13.2650299 5.83741604,12.6009358 5.42806952,12.1913273 C4.04228663,10.8047059 3.27914439,8.96104813 3.27914439,7 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6160428,1.54616898 C7.61074439,1.54616898 5.1657754,3.99276257 5.1657754,7 C5.1657754,10.0072374 7.61074439,12.453831 10.6160428,12.453831 C13.6213412,12.453831 16.0663102,10.0072374 16.0663102,7 C16.0663102,3.99276257 13.6213412,1.54616898 10.6160428,1.54616898 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2862267,0.325361497 C16.8769326,-0.0842470588 16.2133102,-0.0841946524 15.8039636,0.325413904 C15.3946171,0.73502246 15.3946695,1.39906417 15.804016,1.80867273 C17.1897465,3.19529412 17.9529412,5.03895187 17.9529412,7 C17.9529412,8.96104813 17.1897989,10.8047059 15.804016,12.1913273 C15.3946695,12.6009358 15.3946171,13.2649775 15.8039636,13.6745861 C16.2131529,14.0840898 16.8767754,14.0843519 17.2862267,13.6746385 C19.0679401,11.8917722 20.0491979,9.52137754 20.0491979,7 C20.0491979,4.47862246 19.0679401,2.10822781 17.2862267,0.325361497 Z",
  id: "Path"
})))));

var SvgSignal = function SvgSignal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "14px",
    viewBox: "0 0 21 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signal.44456e5e.svg";
export { ForwardRef as ReactComponent };